<template>
  <div class="dashboard">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-6 col-12 dashboard-item d-flex align-items-center">
                    <router-link class="secondary-a" :to="{ name: 'client.profile' }">
                      <div class="icon">
                        <img src="@/assets/icons/register.png" alt />
                      </div>
                      <div class="description">Alteração de Cadastro</div>
                    </router-link>
                  </div>
                  <div
                    class="col-lg-6 col-12 dashboard-item d-flex align-items-center"
                    v-if="canAccessItem('Consultoria')"
                  >
                    <router-link class="secondary-a" :to="{ name: 'client.consultings' }">
                      <div class="icon">
                        <i class="fa fa-question-circle" aria-hidden="true"></i>
                      </div>
                      <div class="description">Dúvidas do Assinante</div>
                    </router-link>
                  </div>
                  <div
                    class="col-lg-6 col-12 dashboard-item d-flex align-items-center"
                    v-if="canAccessItem('Revistas On-line')"
                  >
                    <router-link class="secondary-a" :to="{name:'client.magazines'}">
                      <div class="icon">
                        <img src="@/assets/icons/magazine.png" alt />
                      </div>
                      <div class="description">Revistas On-line</div>
                    </router-link>
                  </div>
                  <div class="col-lg-6 col-12 dashboard-item d-flex align-items-center">
                    <router-link class="secondary-a" :to="{ name: 'client.history' }">
                      <div class="icon">
                        <i class="fa fa-history" aria-hidden="true"></i>
                      </div>
                      <div class="description">Histórico de Textos Acessados</div>
                    </router-link>
                  </div>
                  <div class="col-lg-6 col-12 dashboard-item d-flex align-items-center">
                    <router-link class="secondary-a" :to="{name:'client.pdf-viewer', params:{ title: 'Legislação Anotada - Anotações ao Pregão', src_path:'/static/legislacao_anotada.pdf' }}">
                      <div class="icon">
                        <img src="@/assets/icons/book-1.png" alt />
                      </div>
                      <div class="description">Legislação Anotada - Anotações ao Pregão</div>
                    </router-link>
                  </div>
                  <div class="col-lg-6 col-12 dashboard-item d-flex align-items-center">
                    <router-link class="secondary-a" :to="{name:'client.pdf-viewer', params:{ title: 'Coleção Governet de Direito Administrativo', src_path:'/static/ebook_direito_adm_01.pdf' }}">
                      <div class="icon">
                        <img src="@/assets/icons/book-2.png" alt />
                      </div>
                      <div class="description">Coleção Governet de Direito Administrativo</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/imports/Helpers";

export default {
  name: "dashboard-client",
  data() {
    return {
      client: {}
    };
  },
  mounted() {
    helper.getClientUserPermissions().then(data => {
      this.client = data;
    });
  },
  methods: {
    canAccessItem(item) {
      if (this.client) {
        return helper.clientCanAccessItem(this.client, item);
      } else {
        return false;
      }
    }
  }
};
</script>


<style lang="scss">
@import "@/styles/General.scss";

.dashboard {
  padding-top: 4vh;
  padding-bottom: 4vh;
  .dashboard-item {
    margin-bottom: 5vh;
    .icon {
      width: 5vw;
      img {
        height: 8vh;
      }
      i {
        font-size: 8vh;
        color: $red_primary;
      }
    }
    .description {
      padding-left: 18px;
      display: flex;
      align-items: center;
    }
    a {
      display: flex;
      color: black;
      text-decoration: none;
    }
  }
  .dashboard-item:hover {
    font-weight: bold;
    cursor: pointer;
  }
}
</style>